import { Box, Button, CircularProgress } from '@mui/material';
import { useRef, useState } from 'react';
import HeiGrid from '../../../../Common/components/HeiGrid/HeiGrid';
import usePageTitle from '../../../../Common/hooks/usePageTitle';
import { SettingsKeys } from '../../../../Common/models/storageSettingsKeys';
import { defaultSorting } from '../../api/models/defaultSorting';
import { exportPavedRoadsProjects } from '../../api/pavedRoadsProjectsHttpClient';
import { usePavedRoadsProjectsGrid } from '../../hooks/usePavedRoadsProjectsGrid';
import styles from '../../views/ProjectList.module.scss';
import { getColumns } from './getPavedRoadsProjectsGridColumns';

const PavedRoadsProjectsGrid = () => {
    usePageTitle('Paved Roads Projects');

    const { fetchGridData } = usePavedRoadsProjectsGrid();
    const callForceRefresh = useRef(null);
    const columns = getColumns();
    const [isExporting, setIsExporting] = useState(false);

    const handleExport = async () => {
        setIsExporting(true);
        try {
            await exportPavedRoadsProjects();
        } catch (error) {
            console.error('Error exporting paved roads projects:', error);
        } finally {
            setIsExporting(false);
        }
    };

    return (
        <div className={styles.view}>
            <HeiGrid
                columns={columns}
                fetchGridData={fetchGridData}
                searchPlaceholder='Search project name, team members, cost center'
                defaultSorting={defaultSorting}
                refFunction={callForceRefresh}
                storageSettingsKey={SettingsKeys.PavedRoadsProjectsGrid}
            />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                <Button
                    variant='outlined'
                    onClick={handleExport}
                    disabled={isExporting}
                    startIcon={isExporting ? <CircularProgress size={16} /> : undefined}
                >
                    Export to CSV
                </Button>
            </Box>
        </div>
    );
};

export default PavedRoadsProjectsGrid;
